<template>
  <nav class="flex justify-between bg-white bb b--near-white items-center">
    <div  class="flex items-center justify-start">
      <router-link :to="{ name: 'index' }" v-if="!logged_in" class="pl2 ml2">
        <brand />
      </router-link>
      <div class="clip-l pv3 pl2 pr3 pointer" v-if="logged_in">
        <button @click.stop="$emit('side-nav-toggle')" class="flex"><burger /></button>
      </div>
      <div class="flex flex-row">
        <portal-target name="nav-bar" class="flex items-center justify-start">
          <!--
          This component can be located anwhere in your App.
          The slot content of the above portal component will be rendered here.
          -->
        </portal-target>
        <portal-target name="nav-bar-2" class="flex items-center justify-start">
          <!--
          This component can be located anwhere in your App.
          The slot content of the above portal component will be rendered here.
          -->
        </portal-target>
      </div>
      <div v-if="$route.meta.title" class="bg-white lh-title f5 pl3-l" id="page_title">
        {{ $route.meta.title }}
      </div>
    </div>
    <div v-if="!logged_in" class="flex-grow flex items-center">
      <!--
      <router-link :to="{ name: 'about' }" class="pv3 ph2 ph3-l f5 link dib black dim mr3 mr4-l">
        О системе
      </router-link>
      -->
    </div>
    <div v-else class="flex items-center">
      <button @click="logout" class="icon-button silver pa3" id="logout">
        <font-awesome-icon icon="sign-out-alt" />
      </button>
    </div>
  </nav>
</template>

<script>
import Brand from './Brand.vue'
import Burger from './Burger.vue'

export default {
  components: {
    Brand,
    Burger
  },
  computed: {
    logged_in () {
      return this.$store.getters['user/loggedIn']
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
    }
  }
}
</script>

<style lang="scss">
nav button {
  border: 0;
  background: transparent;

}

nav button svg {
  width: 25px;
  height: 16px;
}
</style>
